<script>
  import { Spinner } from '@client/components/spinner';

  import { SignaturesService } from '@client/services/signatures';

  export let show = false;
  export let user = {};
  export let blockname = null;

  let containerRef = null;
  let fetchingSignature = false;
  let iframeLoaded = false;
  let html = '';
  let adjustX = false;
  let adjustY = false;

  const getSignature = async (email = 'test@recipient.com') => {
    if (email.includes('*@')) {
      email = 'test@recipient.com';
    }

    const data = {
      username: email,
      testData: {
        testsender: email
      }
    };

    if (blockname) {
      data.scratchblockname = blockname;
    }

    const { rendered } = await SignaturesService.getSignature(data);

    return rendered;
  };

  const onIframeLoad = function () {
    const body = this.contentWindow.document.body;
    const content = body.firstChild;

    this.style.visibility = 'visible';
    this.style.opacity = 1;
    this.style.height = (this.contentWindow.document.body.firstChild.clientHeight + 20) / 2 + 'px';
    this.style.width = (this.contentWindow.document.body.firstChild.clientWidth + 20) / 2 + 'px';

    iframeLoaded = true;
  };

  const positionPreview = (element) => {
    if (!element) {
      adjustX = false;
      adjustY = false;
      return;
    }

    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    adjustX = rect.right > viewportWidth;
    adjustY = rect.bottom > viewportHeight;
  };

  const showPreview = async () => {
    iframeLoaded = false;

    if (!containerRef) {
      return;
    }

    positionPreview(containerRef);

    if (!html) {
      fetchingSignature = true;
      html = await getSignature(user.email);
      fetchingSignature = false;
    }
  };

  $: if (!show) {
    adjustX = false;
    adjustY = false;
  }

  $: if (show) {
    setTimeout(showPreview, 0);
  }
</script>

{#if show}
  <div bind:this={containerRef} class="preview" class:adjust-x={adjustX} class:adjust-y={adjustY}>
    {#if html}
      <iframe
        tabindex="-1"
        style="width: 100%; opacity: 0; visibility: hidden;"
        scrolling="no"
        title="preview"
        on:load={onIframeLoad}
        srcdoc={`<html><body style='transform: scale(.5,.5); transform-origin: left top; -moz-transform: scale(.5,.5); -moz-transform-origin: left top;'>${html}</body></html>`}
      />
    {/if}

    {#if fetchingSignature || !iframeLoaded}
      <Spinner show />
    {/if}
  </div>
{/if}

<style lang="scss" src="./signature-preview.scss"></style>
